/**
 * Color to be used when text format contains none
 */
export const FALLBACK_TEXT_COLOR = "#000000";

/**
 * Font-size to be used when text format contains none
 */
export const FALLBACK_TEXT_SIZE = 12;

/**
 * Font to be used when text format contains none
 */
export const FALLBACK_TEXT_FONT = "Arial";

/**
 * Passive (non-hovered) color to be used for links when text has no specified color (and hence would use `FALLBACK_TEXT_COLOR`)
 */
export const DEFAULT_PASSIVE_LINK_COLOR = `#0000FF`;

/**
 * Link hover color to be used for white text
 */
export const WHITE_TEXT_PASSIVE_LINK_COLOR = `#f7bea8`;

/**
 * Link hover color to be used for dark texts
 */
export const DARK_TEXT_PASSIVE_LINK_COLOR = `#418119`;

/**
 * Fallback color to be used for underlines if text format has no specified color
 * (in which case the text would use `FALLBACK_TEXT_COLOR`)
 */
export const FALLBACK_UNDERLINE_COLOR = FALLBACK_TEXT_COLOR;

/**
 * The gutter/padding on each side of the `TextField`
 * 
 * see https://help.adobe.com/en_US/FlashPlatform/reference/actionscript/3/flash/text/TextLineMetrics.html#width
 */
export const TEXT_GUTTER_WIDTH = 2;